"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseScriptTasks = void 0;
const index_1 = require("../../../../Model/index");
const TypeFactory_1 = require("../../../TypeFactory");
const ActivityFactory_1 = require("./ActivityFactory");
function parseScriptTasks(processData) {
    const scriptTasksRaw = (0, TypeFactory_1.getModelPropertyAsArray)(processData, index_1.BpmnTags.TaskElement.ScriptTask);
    const noScriptTasksFound = !((scriptTasksRaw === null || scriptTasksRaw === void 0 ? void 0 : scriptTasksRaw.length) > 0);
    if (noScriptTasksFound) {
        return [];
    }
    const scriptTasks = scriptTasksRaw.map((scriptTaskRaw) => {
        const flowNodeId = scriptTaskRaw.id;
        try {
            return parseScriptTask(scriptTaskRaw);
        }
        catch (error) {
            error.additionalInformation = {
                ...error.additionalInformation,
                flowNodeId: flowNodeId,
            };
            throw error;
        }
    });
    return scriptTasks;
}
exports.parseScriptTasks = parseScriptTasks;
function parseScriptTask(scriptTaskRaw) {
    const scriptTask = (0, ActivityFactory_1.createActivityInstance)(scriptTaskRaw, index_1.Model.Activities.ScriptTask);
    scriptTask.scriptFormat = scriptTaskRaw.scriptFormat;
    scriptTask.script = scriptTaskRaw[index_1.BpmnTags.FlowElementProperty.BpmnScript];
    scriptTask.resultVariable = scriptTaskRaw[index_1.BpmnTags.CamundaProperty.ResultVariable];
    return scriptTask;
}
//# sourceMappingURL=ScriptTaskParser.js.map